import { SubAPI } from "./SubAPI";
export class Report extends SubAPI {
    generate(input) { return this.fetcher.post("/api/reports/generate", input); }
}
